/* eslint jsx-a11y/no-static-element-interactions:0 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import CONST from 'app/common/lib/Const';
import cx from 'classnames';
import groupBy from 'lodash/groupBy';
import i18n from 'app/common/lib/i18n';
import PropTypes from 'prop-types';
import ResourceFactory from 'app/common/lib/ResourceFactory';
import Typeahead from 'app/common/react/components/growth/unauth/open/search/Typeahead/Typeahead';
import withResource from 'app/common/lib/react/withResource';
import { compose } from 'redux';

const classes = ['OpenTypeahead'];

const styles = {
  typeahead: {
    margin: '41px 0px 0px',
    position: 'absolute',
    borderRadius: '0px 0px 6px 6px',
    top: 0,
  },
};

class SearchTypeahead extends Component {
  static propTypes = {
    className: PropTypes.string,
    emptySuggestions: PropTypes.arrayOf(
      PropTypes.shape({
        class_name: PropTypes.string,
        label: PropTypes.string,
        query: PropTypes.string,
        type: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
    focused: PropTypes.bool,
    hoverItem: PropTypes.shape({
      class_name: PropTypes.string,
      label: PropTypes.string,
      query: PropTypes.string,
      type: PropTypes.string,
      url: PropTypes.string,
    }),
    maxHeight: PropTypes.number,
    onHover: PropTypes.func,
    onTypeaheadItemSelected: PropTypes.func,
    onTypeaheadMouseOut: PropTypes.func,
    onTypeaheadSuggestionsChange: PropTypes.func,
    refreshData: PropTypes.func,
    typeaheadSuggestions: PropTypes.arrayOf(
      PropTypes.shape({
        class_name: PropTypes.string,
        label: PropTypes.string,
        query: PropTypes.string,
        type: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
    updateEmptySuggestions: PropTypes.func,
    value: PropTypes.string.isRequired,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.emptySuggestions && this.props.emptySuggestions !== nextProps.emptySuggestions) {
      // Used for caching emptySuggestions in the parent component.
      // (Only triggered once)
      this.props.updateEmptySuggestions(nextProps.emptySuggestions);
    }
  }

  getListItem = (contents, result, index) => (
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
    <li
      key={index}
      onBlur={() => {}}
      onClick={() => this.handleOnClick(result)}
      onFocus={() => this.props.onHover(result)}
      onMouseDown={(e) => {
        e.preventDefault();
      }}
      onMouseOut={(e) => {
        e.preventDefault();
      }}
      onMouseOver={() => this.props.onHover(result)}
    >
      {contents}
    </li>
    /* eslint-enable */
  );

  handleKeyDown = (e) => {
    let newHoverItem;
    const item = this.props.hoverItem;
    const suggestions = this.state.typeaheadSuggestions;
    if (e.keyCode === CONST.KeyCode.UP) {
      if (!item) {
        newHoverItem = suggestions[suggestions.length - 1];
      } else if (suggestions.indexOf(item) === 0) {
        newHoverItem = undefined;
      } else {
        newHoverItem = suggestions[suggestions.indexOf(item) - 1];
      }
    }
    return newHoverItem;
  };

  handleOnClick = (result) => {
    this.props.onTypeaheadItemSelected(result, this.props.value);
  };

  handleRemoveRecentQuery = (query, i) => {
    if (query) {
      const resource = ResourceFactory.create('TypeaheadClearRecentResource', {
        query,
      });
      resource.callDelete().then(this.props.refreshData());
      const newSuggestions = this.props.emptySuggestions.slice();
      const idx = newSuggestions.findIndex((suggestion) => suggestion.resultIndex === i);
      newSuggestions.splice(idx, 1);
      this.props.updateEmptySuggestions(newSuggestions);
    }
  };

  render() {
    const {
      className,
      emptySuggestions,
      focused,
      hoverItem,
      typeaheadSuggestions,
      value,
    } = this.props;

    const classNamesString = cx(classes, className, 'typeaheadWithTitles', { open: focused });

    let scrollStyle;
    const maxHeight = this.props.maxHeight;
    if (focused && maxHeight) {
      scrollStyle = {
        maxHeight,
        overflowY: 'auto',
      };
    }

    const resultsOrder = ['query', 'user', 'board', 'recent_query', 'trending'];

    const titles = {
      board: i18n._('Boards'),
      recent_query: i18n._('Recent searches'),
      trending: i18n._('Trending ideas'),
      user: i18n._('People'),
    };

    const suggestions = !value && emptySuggestions ? emptySuggestions : typeaheadSuggestions;

    const groupedResults = groupBy(suggestions, (result) => result.type);
    const results = [];
    let i = 0;

    resultsOrder.forEach((type) => {
      if (groupedResults[type]) {
        if (type !== 'query') {
          results.push(
            <li key={i}>
              <a
                className="titleItem"
                style={{
                  cursor: 'default',
                  backgroundColor: 'inherit',
                }}
              >
                <span className="typeaheadName">{titles[type]}</span>
              </a>
            </li>,
          );
          i += 1;
        }

        groupedResults[type].forEach((result) => {
          result.resultIndex = result.resultIndex || i;
          let liElement;
          const anchorStyle = {
            backgroundColor: hoverItem === result ? '#f1f1f1' : 'inherit',
            color: result.color ? result.color : '',
          };

          switch (type) {
            case 'query':
              const enteredTerm = value.toLowerCase();
              let darkLabelText, lightLabelText;
              if (result.label.indexOf(value) === 0) {
                darkLabelText = enteredTerm;
                lightLabelText = result.label.slice(enteredTerm.length);
              } else {
                lightLabelText = result.label;
              }
              liElement = (
                <a style={anchorStyle}>
                  <span className="typeaheadName">
                    <span className="darkText">{darkLabelText}</span>
                    <span className="lightText">{lightLabelText}</span>
                  </span>
                </a>
              );
              break;
            case 'user':
              liElement = (
                <a className="user" style={anchorStyle}>
                  <span className="typeaheadImg">
                    <img alt="" src={result.image_small_url} />
                  </span>
                  <span className="typeaheadName">
                    <div className="label">{result.label}</div>
                    <div className="subLabel">{result.subLabel}</div>
                  </span>
                </a>
              );
              break;
            case 'board':
              liElement = (
                <a className="board" style={anchorStyle}>
                  <span className="typeaheadImg">
                    <img alt="" src={result.image_thumbnail_url} />
                  </span>
                  <span className="typeaheadName">
                    <div className="label">{result.label}</div>
                    <div className="subLabel">{result.subLabel}</div>
                  </span>
                </a>
              );
              break;
            case 'recent_query':
              /* eslint-disable jsx-a11y/interactive-supports-focus */
              /* eslint-disable jsx-a11y/click-events-have-key-events */
              liElement = (
                <a className="recentQuery" style={anchorStyle}>
                  <span
                    className="remove"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      this.handleRemoveRecentQuery(result.label, result.resultIndex);
                    }}
                    role="button"
                  />
                  <span className="typeaheadName">{result.label}</span>
                </a>
              );
              /* eslint-enable jsx-a11y/interactive-supports-focus */
              /* eslint-enable jsx-a11y/click-events-have-key-events */
              break;
            case 'trending':
              liElement = (
                <a className={result.class_name} style={anchorStyle}>
                  <span className="typeaheadName">
                    <span className="darkText">{result.label}</span>
                  </span>
                </a>
              );
              break;
            default:
              break;
          }
          results.push(this.getListItem(liElement, result, i));
          i += 1;
        });
      }
    });

    return (
      <Typeahead
        onTypeaheadSuggestionsChange={this.props.onTypeaheadSuggestionsChange}
        resourceName="AdvancedTypeaheadResource"
        value={value}
      >
        <div className={classNamesString} onKeyDown={this.handleKeyDown} style={styles.typeahead}>
          <ul
            className="results"
            onBlur={this.props.onTypeaheadMouseOut}
            onMouseOut={this.props.onTypeaheadMouseOut}
            style={scrollStyle}
          >
            {results}
          </ul>
        </div>
      </Typeahead>
    );
  }
}

export default compose(
  withResource({
    name: 'TrendingQueriesResource',
    key: 'trendingQueriesResource',
  }),
  connect((_, props) => ({
    emptySuggestions: [
      ...(props.trendingQueriesResource.data || []).map((q, idx) => ({
        ...q,
        class_name: `trending-${idx}`,
      })),
    ],
  })),
)(SearchTypeahead);
